.rootLabel {
  margin-right: var(--tuna-spacing-1);
}

.buttonGroupWrap {
  flex-wrap: wrap;
  flex: 1;
}

.noteButton {
  text-transform: none;
  padding: 0;
}

.noneButton {
  text-transform: none;
  padding: 0;
  padding-left: var(--tuna-spacing-1);
  padding-right: var(--tuna-spacing-1);
}

.rootRow {
  margin-top: var(--tuna-spacing-1);
  gap: var(--tuna-spacing-2);
  display: flex;
}

.scaleTypeSelect {
  min-width: 200px;
  position: relative;
}

/* Song key popover (song key K2, #2750, spec §6): 12 roots as a 6x2 grid of 44px targets */
.gridLayout {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1_5);
}

.rootGrid {
  display: grid;
  grid-template-columns: repeat(6, minmax(44px, 1fr));
  gap: var(--tuna-spacing-0_5);
}

.gridButton {
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  text-transform: none;
}

.gridActions {
  display: flex;
  align-items: flex-end;
  gap: var(--tuna-spacing-1);
  flex-wrap: wrap;
}

.gridNone {
  min-height: 44px;
  text-transform: none;
}
